import request from "@/router/axios";

// 客户数据修改列表数据查询
export const findCustomerDataModificationView = (current, size, params) => {
    return request({
      url: `/api/blade-dataModification/modification/find-customerDataModification-view`,
      method: "post",
      data: {
        ...params,
        current,
        size,
      },
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    });
  }
  
// 客户数据修改列表数据详情
export const findCustomerDataModificationViewDetail = (id) => {
  return request({
    url: `/api/blade-dataModification/modification/find-customerDataModification-view-detail/${id}`,
    method: "get",
  });
}

// 客户数据修改-保存修改信息
export const findCustomerDataModificationEdit = (params) => {
  return request({
    url: `/api/blade-dataModification/modification/find-customerDataModification-edit`,
    method: "post",
    data: params
  });
}

// 分页(按照最后修改时间排序)
export const loanCustomerDataRecordsSelectList = (id) => {
  return request({
    url: `/api/blade-loanCustomerDataRecords/loanCustomerDataRecords/selectList/${id}`,
    method: "get",
  });
}

// 分页(按照最后修改时间排序)
export const fascContractId = (id) => {
  return request({
    url: `/api/blade-fascContract/fascContract/retry/contract/${id}`,
    method: "get",
  });
}

/**
 * 重发合同
 * 抵押合同/声明合同(多选)
 */
export const retryContract = (data) => {
  return request({
    url: `/api/blade-fascContract/fascContract/retry/contract`,
    method: "post",
    data
  });
}